import { Spinner } from "@/components/ui/spinner";
import { AlertTriangle } from "lucide-react";
import { RefObject } from "react";
import { createPortal } from "react-dom";
import { MapRef } from "react-map-gl/maplibre";

export type MapStatus = "loading" | "processing" | "error" | null;

const MESSAGES: Record<Exclude<MapStatus, null>, string> = {
  loading: "Loading boundary…",
  processing: "Processing the uploaded boundary…",
  error: "The boundary could not be loaded.",
};

interface MapStatusOverlayProps {
  mapRef: RefObject<MapRef | undefined>;
  status: MapStatus;
}

export const MapStatusOverlay = ({ mapRef, status }: MapStatusOverlayProps) => {
  const container = mapRef.current?.getContainer();
  if (!status || !container) return null;

  // The installed react-dom types return a ReactPortal the react types don't accept as a node.
  return createPortal(
    <div className="absolute top-4 left-1/2 -translate-x-1/2 z-10 pointer-events-none">
      <div
        role="status"
        data-testid="clip-map-status"
        className="flex items-center gap-2 rounded-md border bg-background/95 px-4 py-2 text-sm shadow-md"
      >
        {status === "loading" || status === "processing" ? (
          <Spinner />
        ) : (
          <AlertTriangle className="size-4 text-warning" />
        )}
        <span>{MESSAGES[status]}</span>
      </div>
    </div>,
    container,
  ) as unknown as JSX.Element;
};
